$('#back-to-top').on('click', function () {
  console.log('scrollTop')
  $(document).scrollTop(0);
})